import React from 'react';
import PropTypes from 'prop-types';
import { IconWarning } from '../../../assets/icons/IconWarning';

export const ErrorMessage = ({ error, errorMessage, showIcon = true }) => (
  (errorMessage || error) && (
    <div className="upload-modal__error" role="alert">
      {showIcon && <IconWarning />}
      <span>{error || errorMessage}</span>
    </div>
  )
);

ErrorMessage.propTypes = {
  error: PropTypes.string,
  errorMessage: PropTypes.string,
  showIcon: PropTypes.bool
};
